import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { Button, CircularProgress } from '@material-ui/core';
import './../../Account/Login.css';
import { useDispatch } from 'react-redux';
import db, { auth } from '../../Backend/firebase/firebase';
import CustomAlert from '../CustomAlert';
import { Helmet } from 'react-helmet';

function CallRetailer({ isCaptchaVisible, retailerDetails, allProducts }) {
    const { register, handleSubmit, reset, errors } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const [verifyCaptcha, setVerifyCaptcha] = useState(false);
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    const handleCaptchaVerification = (response) => {
        if (response) {
            setVerifyCaptcha(true);
        }
        else {
            setVerifyCaptcha(false);
        }
    };

    const routeToPages = () => {
        window.location.pathname = '/';
    }

    const onSubmit = async (data) => {
        setIsLoading(true);
        var retailerCallData = {
            name: data.name,
            email: data.email,
            phone: data.phone,
            retailer: retailerDetails,
            product: data.product
        };
        console.log("retailerCallData",retailerCallData)
        // try {
        //     var event = createCallRetailerDocument(retailerCallData);
        //     if (event) {
        //         setNotificationMessage('Enquiry Submitter successfully. Will get back to you!');
        //         setOpenNotify(true);
        //         setAlertType('success');
        //         setIsLoading(false);
        //         setTimeout(routeToPages, 2000);
        //     } else {
        //         setNotificationMessage('Something went wrong, Please try again later!!');
        //         setOpenNotify(true);
        //         setAlertType('error');
        //         setIsLoading(false);
        //     }
        // }  catch (error) {
        //     console.error(error);
        //     setNotificationMessage('Something went wrong, Please try again later!!');
        //     setOpenNotify(true);
        //     setAlertType('error');
        //     setIsLoading(false);
        // }
    };


    return (
        <>
            <div className="callRetailer">
                <Helmet>
                    <meta name="description" content="To login yourseld to use this website..." />
                    <title>Retailer - Call Now | Kaipsool Pharmatech</title>
                </Helmet>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="retailer__textboxLabel">Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <input type="text" className={classNames("form-control retailer__textbox", { "is-invalid": errors.name })}
                                    name="name" placeholder="Name" autoComplete="off"
                                    ref={register({ required: 'Please enter your Name!' })} />
                                <small className="form-text text-danger">{errors.name && errors.name.message}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="retailer__textboxLabel">Email Address <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <input type="email" className={classNames("form-control retailer__textbox", { "is-invalid": errors.email })}
                                    name="email" placeholder="Email Address" autoComplete="off"
                                    ref={register({ required: 'Please enter your email address!' })} />
                                <small className="form-text text-danger">{errors.email && errors.email.message}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="retailer__textboxLabel">Mobile Number <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <input type="text" className={classNames("form-control retailer__textbox", { "is-invalid": errors.phone })}
                                    name="phone" placeholder="Phone" autoComplete="off"
                                    ref={register({ required: 'Please enter your Phone!' })} />
                                <small className="form-text text-danger">{errors.phone && errors.phone.message}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="retailer__textboxLabel">Select Product <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.product })} aria-label="Default select example"
                                    name="product" ref={register({
                                        required: 'Please select Product!',
                                        validate: {
                                            defaultValue: value => value !== "Select Product" || 'Please select Product!'
                                        }
                                    })} defaultValue="Select Product">
                                    {allProducts.map((products)=> {
                                        return <option value={`${products.ProductName} - Rs. ${products.MRP} per ${products.PackagingSize} with ${products.Discount}% Discount`}>{`${products.ProductName} - Rs. ${products.MRP} per ${products.PackagingSize} with ${products.Discount}% Discount`}</option>
                                    })}
                                </select>
                                <small className="form-text text-danger">{errors.product && errors.product.message}</small>
                            </div>
                        </div>
                        <div className="col-sm-12 text-center mt-2">
                            <div className="d-flex justify-content-center">
                                <div className="p-2">
                                    <Button type="submit" variant="contained" color="primary" size="small"
                                        className="login__btn">
                                        {isLoading ? <CircularProgress size={18} /> : 'Submit'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default CallRetailer
